import { css } from "@emotion/react";
import React, { forwardRef } from "react";
import { ShimmerEffectBox } from "../ShimmerEffect";
import { isNonNullish } from "../@utils/isNonNullish";
import { useTheme } from "../theme";

export interface InputLabelProps extends React.ComponentPropsWithoutRef<"label"> {
  required?: boolean;
  loading?: boolean;
}

export const InputLabel = forwardRef<HTMLLabelElement, InputLabelProps>(
  ({ required, loading, children, ...props }, ref) => {
    const theme = useTheme();
    return isNonNullish(children) ? (
      <label
        css={[
          theme.typography.caption,
          css`
            &[aria-disabled="true"] {
              color: ${theme.palette.text.disabled};
            }
          `,
        ]}
        {...props}
        ref={ref}
      >
        {loading ? (
          <ShimmerEffectBox
            height={
              theme.typography.caption.fontSize *
              theme.typography.caption.lineHeight
            }
            width={56}
            fontSize={theme.typography.caption.fontSize}
          />
        ) : (
          <>
            {children}
            {required ? (
              <span
                css={css`
                  color: ${theme.palette.intentions.error.main};
                `}
              >
                *
              </span>
            ) : null}
          </>
        )}
      </label>
    ) : null;
  },
);
